import React, { useState, useEffect } from 'react';
import SideMenu from "../../component/SideMenu";
import Topbar from "../../component/Topbar";
import SettingNav from './SettingNav';
import { LuRuler, LuMap } from "react-icons/lu";
import "../../asset/css/profile-info.css";
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';

// Simple Skeleton Component to prevent layout shift
const SkeletonCard = () => (
    <div className="premium-card h-100 skeleton-animate">
        <div className="section-header">
            <div className="skeleton-circle"></div>
            <div style={{ flex: 1 }}>
                <div className="skeleton-line short"></div>
                <div className="skeleton-line"></div>
            </div>
        </div>
        <div className="form-body">
            <div className="skeleton-line mb-3" style={{ height: '80px' }}></div>
            <div className="skeleton-line mb-3"></div>
            <div className="skeleton-line mb-3"></div>
        </div>
        <div className="mt-auto">
            <div className="skeleton-line" style={{ height: '45px', width: '120px' }}></div>
        </div>
    </div>
);

const Measurement = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    

    const [reportOptions, setReportOptions] = useState([]);


    const [config, setConfig] = useState({
        measurement_unit: 'Sqft',
        default_report_type: 'Landscaping + Snow',
        autosave_interval: 'Every 5 minutes',
        show_grid: true,
        auto_zoom: true,
        default_satellite: true,
        show_labels: true,
        default_map_type: 'Satellite'
    });

    const userToken = localStorage.getItem('userToken');
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });



    useEffect(() => {
    const fetchPackages = async () => {
        try {
            const res = await axios.get(`${baseurl}getAllServicePackagesUser`, {
                headers: { Authorization: `Bearer ${userToken}` }
            });
            if (res.data.success) {
                setReportOptions(res.data.data);
            }
        } catch (err) {
            console.error("Error fetching packages:", err);
        }
    };
    fetchPackages();
}, [userToken]);



    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await axios.get(`${baseurl}getUserPreferences`, {
                    headers: { Authorization: `Bearer ${userToken}` }
                });
                if (res.data.success && res.data.data.measurement_settings) {
                    // Merge database data with defaults to handle new keys added in code
                    setConfig(prev => ({ 
                        ...prev, 
                        ...res.data.data.measurement_settings 
                    }));
                }
            } catch (err) {
                console.error("Fetch Error:", err);
            } finally {
                // Keep the skeleton visible for at least 500ms for better UX
                setTimeout(() => setFetching(false), 500);
            }
        };
        fetchSettings();
    }, [userToken]);

    const handleToggle = (name, value) => {
        setConfig(prev => ({ ...prev, [name]: value }));
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setConfig(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const saveSettings = async () => {
        setIsLoading(true);
        try {
            const res = await axios.put(`${baseurl}updateUserPreferences`, {
                column: 'measurement_settings',
                data: config
            }, {
                headers: { Authorization: `Bearer ${userToken}` }
            });

            if (res.data.success) {
                Toast.fire({ icon: 'success', title: 'Settings saved successfully' });
            }
        } catch (err) {
            Toast.fire({ icon: 'error', title: 'Update failed' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="app-container">
            <Topbar />
            <div className="main-wrapper" style={{ background: '#F4F7FE' }}>
                <SideMenu />
                <div className="profile-content-container p-3" style={{ flex: 1, overflow: 'auto' }}>
                    <SettingNav />

                    <div className="row g-3 mt-0">
                        {fetching ? (
                            <>
                                <div className="col-lg-6"><SkeletonCard /></div>
                                <div className="col-lg-6"><SkeletonCard /></div>
                            </>
                        ) : (
                            <>
                                {/* LEFT CARD: Measurement Units */}
                                <div className="col-lg-6">
                                    <div className="premium-card h-100">
                                        <div className="section-header">
                                            <div className="icon-wrap profile-icon"><LuRuler /></div>
                                            <div>
                                                <h5 className="card-title">Measurement Units</h5>
                                                <p className="card-subtitle">Global unit preferences</p>
                                            </div>
                                        </div>

                                        <div className="form-body">
                                            <div className="unit-toggle-container">
                                                <button 
                                                    className={`unit-btn ${config.measurement_unit === 'Sqft' ? 'active' : ''}`}
                                                    onClick={() => handleToggle('measurement_unit', 'Sqft')}
                                                >
                                                    <span className="unit-title">Sqft </span>
                                                    <span className="unit-desc">Square Feet</span>
                                                </button>
                                                <button 
                                                    className={`unit-btn ${config.measurement_unit === 'acres' ? 'active' : ''}`}
                                                    onClick={() => handleToggle('measurement_unit', 'acres')}
                                                >
                                                    <span className="unit-title">Acres</span>
                                                    <span className="unit-desc">Acres</span>
                                                </button>
                                            </div>

                                           <div className="input-block mt-3">
    <label className="input-label">Default Report Type</label>
    <select 
        name="default_report_type" 
        value={config.default_report_type} 
        onChange={handleInputChange} 
        className="form-control-premium form-select"
    >
        {reportOptions.length > 0 ? (
            reportOptions.map((pkg) => (
                <option key={pkg.id} value={pkg.name}>
                    {pkg.name}
                </option>
            ))
        ) : (
            <option>Loading types...</option>
        )}
    </select>
</div>

                                            <div className="input-block">
                                                <label className="input-label">Auto-Save Interval</label>
                                                <select name="autosave_interval" value={config.autosave_interval} onChange={handleInputChange} className="form-control-premium form-select">
                                                    <option>Every 5 minutes</option>
                                                    <option>Every 15 minutes</option>
                                                    <option>On every change</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="card-footer-actions mt-auto">
                                            <button className="btn-save-changes" onClick={saveSettings} disabled={isLoading}>
                                                {isLoading ? 'Saving...' : 'Save Settings'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* RIGHT CARD: Map & Display Settings */}
                                <div className="col-lg-6">
                                    <div className="premium-card h-100">
                                        <div className="section-header">
                                            <div className="icon-wrap security-icon"><LuMap /></div>
                                            <div>
                                                <h5 className="card-title">Map & Display Settings</h5>
                                                <p className="card-subtitle">Visual preferences</p>
                                            </div>
                                        </div>

                                        <div className="form-body">
                                            <div className="checkbox-list">
                                                {[
                                                    { id: 'show_grid', label: 'Show measurement grid on maps' },
                                                    { id: 'auto_zoom', label: 'Auto-zoom to property boundaries' },
                                                    { id: 'default_satellite', label: 'Show satellite view by default' },
                                                    { id: 'show_labels', label: 'Show measurement labels on map' }
                                                ].map(item => (
                                                    <label className="checkbox-item" key={item.id}>
                                                        <input name={item.id} type="checkbox" checked={config[item.id]} onChange={handleInputChange} />
                                                        <span className="checkmark"></span>
                                                        <span className="checkbox-label">{item.label}</span>
                                                    </label>
                                                ))}
                                            </div>

                                            <div className="input-block mt-3">
                                                <label className="input-label">Default Map Type</label>
                                                <select name="default_map_type" value={config.default_map_type} onChange={handleInputChange} className="form-control-premium form-select">
                                                    <option>Terrain</option>
                                                    <option>Satellite</option>
                                                    <option>Hybrid</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="card-footer-actions mt-auto">
                                            <button className="btn-save-changes" onClick={saveSettings} disabled={isLoading}>
                                                {isLoading ? 'Saving...' : 'Save Display Settings'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <style>
              {`
              .skeleton-animate {
    background: #fff;
    pointer-events: none;
}

.skeleton-line {
    height: 15px;
    margin-bottom: 10px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 4px;
}

.skeleton-line.short { width: 40%; }

.skeleton-circle {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    margin-right: 15px;
}

@keyframes skeleton-loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}
`}
            </style>
        </div>
    );
};

export default Measurement;